import { FormGroup, Typography } from '@mui/material';
import { format } from 'date-fns';
import React, { useState } from 'react';
import { FieldValues, UseFormWatch } from 'react-hook-form';

import { WsDatePicker } from '../../../components/WsDatePicker';
import { WsTypoVariants, WsTypoColors } from '../../WsTypography/WsTypography';
import EditCommonComponent from '../EditCommonComponent';

export interface DateEditProps {
  fieldName: string;
  defaultValue: Date | string;
  onConfirm: (key: string, value: Date) => void;
  textVariant?: WsTypoVariants;
  color?: WsTypoColors;
  watch: UseFormWatch<FieldValues>;
  disabled?: boolean;
}

const DateEdit = ({
  fieldName,
  defaultValue,
  onConfirm,
  textVariant,
  color,
  watch,
  disabled = false,
}: DateEditProps) => {
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [tempValue, setTempValue] = useState<Date>(
    defaultValue instanceof Date ? defaultValue : new Date(defaultValue)
  );

  const fromDate = watch(fieldName);

  const handleConfirm = () => {
    onConfirm(fieldName, fromDate);
    setIsEdit(false);
    setTempValue(fromDate);
  };

  const handleClose = () => {
    setIsEdit(false);
  };

  return (
    <Typography
      variant={textVariant}
      color={color}
      sx={{
        overflow: 'hidden',
        display: 'block',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        cursor: disabled ? 'default' : 'pointer',
      }}
      onClick={disabled ? undefined : () => setIsEdit(!isEdit)}
    >
      {isEdit && !disabled ? (
        <FormGroup>
          <WsDatePicker name={fieldName} label={fieldName} disabled={disabled} />
          <EditCommonComponent onClose={handleClose} onConfirm={handleConfirm} />
        </FormGroup>
      ) : tempValue instanceof Date && !isNaN(tempValue.getTime()) ? (
        format(tempValue, 'dd/MM/yyyy')
      ) : (
        defaultValue
      )}
    </Typography>
  );
};

export default DateEdit;
